import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { Enums, MailboxList } from "@msuite/utils/types";
import { client } from "@/hono";

export function useMailboxes(purpose: Enums<"mailboxPurpose">) {
	/** Query */
	const query = useQuery({
		queryKey: ["mailboxes", purpose],
		queryFn: async () => {
			const response = await client.mailboxes.index.$get({ query: { purpose } });
			const data = await responseHandler(response);
			return data.mailboxes as MailboxList;
		},
		// The poll job writes the state column every few minutes; the table follows without a
		// reload so "Fetch now" is seen to do something.
		refetchInterval: 30_000,
	});

	/** Return */
	return { ...query, mailboxes: query.data ?? [] };
}
